import { useUserNameMap } from '../lib/useUsers';
import { formatDate } from '../lib/orgTimezone';

/**
 * LastUpdated — "Last updated by {name} · {date}" line for entity detail headers
 * (migration 101). Resolves updated_by (a user id) → display name via
 * useUserNameMap (users → contacts). Renders nothing when the row carries
 * neither an updater nor an updated_at (e.g. a legacy row never edited since the
 * column was added).
 *
 *   both        → "Last updated by Maria Delgado · Jul 23, 2026"
 *   name only   → "Last updated by Maria Delgado"
 *   date only   → "Last updated Jul 23, 2026"
 */

export interface LastUpdatedProps {
  updatedBy?: string | null;
  updatedAt?: string | null;
}

export function LastUpdated({ updatedBy, updatedAt }: LastUpdatedProps) {
  const names = useUserNameMap();
  if (!updatedBy && !updatedAt) return null;

  const name = updatedBy ? names[updatedBy] || 'a teammate' : null;
  const date = updatedAt ? formatDate(updatedAt) : null;

  const lead = name ? `Last updated by ${name}` : 'Last updated';
  const text = date ? `${lead} · ${date}` : lead;

  return (
    <div
      style={{
        marginTop: 'var(--sp-1)',
        color: 'var(--color-ink-3)',
        fontSize: 'var(--fs-sm)',
      }}
    >
      {text}
    </div>
  );
}
